/* eslint-disable max-len */
import BlogImage1 from "assets/images/blog.image.1.png";
import BlogImage2 from "assets/images/blog.image.2.png";
import BlogImage3 from "assets/images/blog.image.3.png";

const MAIN_HEADING = "Check out some of our informative blog posts below.";

const BLOG_POSTS_DATA = [
	{
		image: BlogImage1,
		imageAlt: "Blog Image 1",
		title: "Jet Ski Storage Tips",
		desc: "Jet skis are great fun for the summer, but need to be stored in cooler temperatures. Learn how to store your jet ski with preparations, features, and self storage."
	},
	{
		image: BlogImage2,
		imageAlt: "Blog Image 2",
		title: "The Complete Guide to Vehicle Storage",
		desc: "Vehicle storage includes more than just your car. It’s also common for people to use self storage for their motorcycles, boats, ATVs, and any other sort of personal vehicle. Look no further, your ultimate resource guide to storing your vehicle is all right here."
	},
	{
		image: BlogImage3,
		imageAlt: "Blog Image 3",
		title: "Storing a Motorcycle in Self Storage",
		desc: "Running out of room in the garage for your motorcycle? Are you being deployed oversees for a while? Do you live in an area with snowy months? Whatever the case may be, storing your motorcycle in a storage unit is a helpful solution. Here is a detailed list that covers everything you need to know about motorcycle storage. "
	}
];

export { MAIN_HEADING, BLOG_POSTS_DATA };
